module.exports = __webpack_public_path__ + "img/SL.d9259b5c.jpg";